<template>
  <RouterView />
  <AppNotificationHost />
  <AppDialogHost />
</template>

<script setup lang="ts">
import AppDialogHost from '@/shared/components/AppDialogHost.vue'
import AppNotificationHost from '@/shared/components/AppNotificationHost.vue'
</script>
